import PageActions from './PageActions'

export default PageActions
